import React from "react";
import { ReactSession } from 'react-client-session';
import {encode as base64_encode} from 'base-64';
import { Modal, ModalBody } from 'reactstrap';

import { Helpers } from "../../config/Helpers";

class Payment extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            loading: true,
            skeleton: true,
            data: [],
            dataDetail: [],
            orderList: [],
            totalOrder: 0,
            showDetailModal: false,
        };
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            this.getListOrder();
            this.getListKolektif();
        }
    }

    getListOrder = () => {
        this.setState({ skeleton: true });

        Helpers.getListOrderCustom(
            'yes',
            this.state.sessUserCode,
            'waiting_pay',
            'all',
            'all',
            '',
            ''
        ).then(res => {
            if(res && res.length > 0){
                this.setState({
                    orderList: res,
                    totalOrder: res.reduce((sum, { GrandTotal }) => sum + parseInt((GrandTotal || '0').toString().replaceAll(".","")), 0),
                    skeleton: false
                });
            }else{
                this.setState({ skeleton: false });
            }
        });
    };

    getListKolektif = () => {
        Helpers.GetKolektifPayment(
            this.state.sessUserCode
        ).then(res => {
            this.setState({
                data: (res) ? res : [],
                loading: false
            });
        });
    };

    detailPayment = (code) => {
        Helpers.GetKolektifPaymentDtl(code).then(res => {
            if(res && res.length > 0){
                this.setState({
                    dataDetail: res,
                    showDetailModal: true
                });
            }
        });
    };

    closeDetailModal = () => {
        this.setState({ showDetailModal: false });
    };

    viewOrder = (kode) => {
        window.location.href = './account-orders-details?trxid=' + base64_encode(kode);
    };

    goList = () => {
        window.location.href = './collective-payment-list';
    };

    render() {
        return (
            <>
                <main className="main pages detail-page-wrap">
                    <div className="detail-topbar">
                        <a href="./account" className="detail-topbar-back"><i className="fi-rs-arrow-small-left"></i></a>
                        <h1 className="detail-topbar-title">Pembayaran Kolektif</h1>
                    </div>

                    <div className="detail-wrap">
                        <div className="detail-card">
                            <div className="detail-card-head">
                                <span className="detail-card-accent"></span>
                                <span className="detail-card-title">Nominal Pesanan Belum Dibayar</span>
                            </div>

                            {
                                this.state.skeleton ? (
                                    <div className="detail-info-box">
                                        <div className="detail-info-row">
                                            <span className="detail-info-label">Memuat data...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="collective-total-value">Rp {this.state.totalOrder.toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</div>
                                        <div className="collective-total-meta">
                                            <i className="fi-rs-document"></i>
                                            <span><strong>{this.state.orderList.length}</strong> Total Pesanan</span>
                                        </div>
                                        <button type="button" className="auth-btn-outline collective-total-btn" onClick={() => {this.goList()}}>Lihat Daftar Pesanan</button>
                                    </>
                                )
                            }
                        </div>

                        <div className="detail-card">
                            <div className="detail-card-head">
                                <span className="detail-card-accent"></span>
                                <span className="detail-card-title">Riwayat Transaksi</span>
                            </div>

                            {
                                this.state.loading ? (
                                    <div className="detail-info-box">
                                        <div className="detail-info-row">
                                            <span className="detail-info-label">Memuat data...</span>
                                        </div>
                                    </div>
                                ) : this.state.data.length > 0 ? (
                                    this.state.data.map((object, i) => (
                                        <div className="collective-history-item" key={i} onClick={() => {this.detailPayment(object.KodeTransaksi)}}>
                                            <div className="collective-history-top">
                                                <span className="collective-history-date">{object.TanggalTransaksi}</span>
                                                <i className={(object.Status === 'in') ? 'fi-rs-download' : 'fi-rs-upload'}></i>
                                                <span className="collective-history-code">{object.KodeTransaksi}</span>
                                                <span className="collective-history-amount">Rp {object.JumlahFormat}</span>
                                            </div>
                                            <div className="collective-history-bottom">
                                                <span>{object.date_t} WIB</span>
                                                <span>{object.StatusLabel}</span>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="order-empty">
                                        <i className="fi-rs-receipt"></i>
                                        <p>Belum ada riwayat pembayaran kolektif</p>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </main>

                <Modal
                    size={'md'}
                    isOpen={this.state.showDetailModal}
                    toggle={() => { this.closeDetailModal() }}
                    contentClassName="modal-picker-content">
                    <ModalBody className="modal-picker-body">
                        <div className="modal-picker-header">
                            <div className="modal-picker-title">
                                <span className="modal-picker-icon"><i className="fi-rs-credit-card"></i></span>
                                Pesanan Yang Dibayar
                            </div>
                            <button type="button" className="modal-picker-close" onClick={() => { this.closeDetailModal() }} aria-label="Tutup">
                                <i className="fi-rs-cross"></i>
                            </button>
                        </div>

                        <div className="modal-picker-list">
                            {
                                this.state.dataDetail.map((object, i) => (
                                    <div
                                        key={i}
                                        className="modal-picker-item"
                                        onClick={() => { this.viewOrder(object.KodeTransaksiOrder) }}
                                    >
                                        <span className="modal-picker-item-text">
                                            <span className="modal-picker-item-title">{object.KodeTransaksiOrder}</span>
                                        </span>
                                        <span className="collective-history-amount">Rp {object.JumlahFormat}</span>
                                    </div>
                                ))
                            }
                        </div>
                    </ModalBody>
                </Modal>
            </>
        );
    }
}

export default Payment;
